import * as angular from "angular";
import { Constants as constants } from "@constants/shared";
import { clientManagement } from "./clientManagement";
import { ClientCRMRepo } from "@services/clients/clientCRM.repo";
import { UnlinkedExternalAccountsRepo } from "@services/portfolios/unlinked-external-accounts.repo";
import { bankModal } from "./modals/bank";
import { professionalActivityModal } from "./modals/professionalActivity";
import { currencyModal } from "./modals/currency";
import { optionsTable } from "@components/options-table/options-table";
import { optionsManager } from "@components/options-manager/options-manager";
import { optionEditModal } from "@components/option-edit-modal/option-edit-modal";
import { unlinkedExternalAccountsComponent } from "./unlinked-external-accounts/unlinked-external-accounts.component";
import { LinkAccountModalComponent } from "./unlinked-external-accounts/link-account-modal.controller";

export const clientManagementModule = "clientmanagement";

angular
  .module(clientManagementModule, [
    "ui.router",
    "dataGrid",
    "pagination",
    "angular-loading-bar",
    "angularModalService",
  ])
  .constant("config", constants.Default)
  .service("clientCRMRepo", ClientCRMRepo)
  .service("unlinkedExternalAccountsRepo", UnlinkedExternalAccountsRepo)
  .component("clientmanagement", clientManagement)
  .component("bankModal", bankModal)
  .component("professionalActivityModal", professionalActivityModal)
  .component("currencyModal", currencyModal)
  .component("optionsTable", optionsTable)
  .component("optionsManager", optionsManager)
  .component("optionEditModal", optionEditModal)
  .component("unlinkedExternalAccounts", unlinkedExternalAccountsComponent)
  .component("linkAccountModal", LinkAccountModalComponent);



// WEBPACK FOOTER //
// ./src/app/clientmanagement/clientmanagement.index.ts